import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ProductSpecification } from 'situview-webapi-client';
import { Guid } from 'guid-typescript';

@Component({
  selector: 'product-specification-edit',
  templateUrl: './product-specification-edit.component.html',
  styleUrls: ['./product-specification-edit.component.less']
})
export class ProductSpecificationEditComponent implements OnChanges {
  @Input() productSpecifications: ProductSpecification[] | undefined = undefined;
  @Input() productTypeIdFilter: string | undefined = undefined;
  @Input() parentProductSpecificationNode: ProductSpecificationNode | undefined = undefined;
  @Output() onSaveUpdate: EventEmitter<ProductSpecification> = new EventEmitter();
  @Output() onSaveAdd: EventEmitter<ProductSpecification> = new EventEmitter();

  createdProductSpecificationNodes: ProductSpecificationNode[] | undefined = undefined;
  
  ngOnChanges(changes: SimpleChanges) {
    if (this.parentProductSpecificationNode) {
      this.createdProductSpecificationNodes = this.parentProductSpecificationNode.children;
    }
    else {
      if (this.productSpecifications) {
        if (this.productTypeIdFilter) {
          this.createdProductSpecificationNodes = ProductSpecificationNode.Build(this.productSpecifications, this.productTypeIdFilter, this.onSaveUpdate);
        } else {
          this.createdProductSpecificationNodes = [];
        }
      }
    }
  }

  addNewNode() {
    var newProductSpecification = new ProductSpecification();
    newProductSpecification.id = Guid.create().toString();
    newProductSpecification.name = "New Product Specification";
    newProductSpecification.productTypeId = this.productTypeIdFilter;
    newProductSpecification.parentSpecificationId = this.parentProductSpecificationNode?.productSpecification.id;
    newProductSpecification.order = 0;
    newProductSpecification.selectable = true;

    var newSpecificationNode = new ProductSpecificationNode(newProductSpecification, undefined, this.productSpecifications!, this.onSaveUpdate);
    newSpecificationNode.addMode = true;

    if (!this.createdProductSpecificationNodes) {
      this.createdProductSpecificationNodes = [newSpecificationNode];
    } else {
      this.createdProductSpecificationNodes?.push(newSpecificationNode);
    }
  }

  saveAdd(node: ProductSpecificationNode) {
    this.onSaveAdd.emit(node.productSpecification)
  }

  cancelAddMode(node: ProductSpecificationNode) {
    this.createdProductSpecificationNodes = this.createdProductSpecificationNodes?.filter(e => e != node);
  }

}

class ProductSpecificationNode {
  productSpecification: ProductSpecification;
  productSpecificationOrig: ProductSpecification;

  children?: ProductSpecificationNode[];
  parent?: ProductSpecificationNode;

  updateMode: boolean = false;
  addMode: boolean = false;

  onSaveUpdate: EventEmitter<ProductSpecification>;

  constructor(productSpecification: ProductSpecification,
    parentProductSpecification: ProductSpecificationNode | undefined,
    productSpecifications: ProductSpecification[],
    onSaveUpdate: EventEmitter<ProductSpecification>) {
    this.productSpecificationOrig = productSpecification;
    this.productSpecification = new ProductSpecification(this.productSpecificationOrig);

    this.children = productSpecifications
      .filter(item => item.parentSpecificationId === productSpecification.id)
      .sort((a, b) => (a.order ?? 100000) - (b.order ?? 100000))
      .map(item => new ProductSpecificationNode(item, this, productSpecifications, onSaveUpdate));

    this.parent = parentProductSpecification;

    this.onSaveUpdate = onSaveUpdate;
  }

  static Build(productSpecifications: ProductSpecification[], productTypeIdFilter: string,
    onSaveUpdate: EventEmitter<ProductSpecification>) : ProductSpecificationNode[]
  {
    if (productSpecifications && productTypeIdFilter)
    {
      return productSpecifications
      .filter(item => item.productTypeId == productTypeIdFilter && !item.parentSpecificationId)
      .sort((a, b) => (a.order ?? 100000) - (b.order ?? 100000))
      .map(item => new ProductSpecificationNode(item, undefined, productSpecifications, onSaveUpdate));
    }
    else
    {
      return [];
    }
  }

  hasChildren() {
    return !!this.children && this.children.length > 0;
  }

  enableUpdateMode() {
    this.updateMode = true;
  }

  saveUpdate() {
    this.onSaveUpdate.emit(this.productSpecification)
    this.updateMode = false;
  }

  cancelUpdateMode() {
    this.productSpecification = new ProductSpecification(this.productSpecificationOrig);
    this.updateMode = false;
  }
}